import { Heading, Text } from "@oysterhr/ui"

interface OverviewStepProps {
  title: string
  content: string
  step: number
}

export const OverviewStep = ({ title, content, step }: OverviewStepProps) => {
  return (
    <div className="col-span-1 grid grid-flow-col gap-2">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-success-base">
        <Text className="font-semibold">{step}</Text>
      </div>
      <div className="flex flex-col items-start justify-center">
        <Heading size="lg" className="text-base font-semibold leading-6">
          {title}
        </Heading>
        <Text size="small" className="mt-1 text-sm leading-5 text-gray-400">
          {content}
        </Text>
      </div>
    </div>
  )
}
